import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from 'store'

import { clearTripPayload } from './trips.slice'
import { SessionCreatedOrderEvent } from './trips.types'

/**
 * Trip-builder session helpers. Order events for entered drop/hook addresses are
 * created on the backend during trip create/update, so cancel/remove no longer
 * soft-deletes order events from the frontend.
 */
export const useSessionOrderEventCleanup = () => {
  const dispatch = useDispatch()
  const sessionCreatedOrderEvents = useSelector(
    (state: RootState) => state.trips.sessionCreatedOrderEvents
  )

  const findSessionEvent = useCallback(
    (orderEventId: number): SessionCreatedOrderEvent | undefined =>
      sessionCreatedOrderEvents.find(
        (event) => event.orderEventId === orderEventId
      ),
    [sessionCreatedOrderEvents]
  )

  const deleteSessionOrderEvent = useCallback(
    async (orderEventId: number): Promise<boolean> => {
      void orderEventId
      return false
    },
    []
  )

  const deleteSessionOrderEvents = useCallback(
    async (orderEventIds: number[]): Promise<void> => {
      void orderEventIds
    },
    []
  )

  const discardSessionOrderEvents = useCallback(
    async (keepOrderEventIds: number[] = []): Promise<void> => {
      void keepOrderEventIds
    },
    []
  )

  const cancelTripCreation = useCallback(async () => {
    dispatch(clearTripPayload())
  }, [dispatch])

  return {
    sessionCreatedOrderEvents,
    findSessionEvent,
    deleteSessionOrderEvent,
    deleteSessionOrderEvents,
    discardSessionOrderEvents,
    cancelTripCreation,
  }
}
